"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathFunctionMap = exports.RoundingType = void 0;
exports.RoundingType = {
    up: 'up',
    down: 'down',
    off: 'off',
    '': '',
};
exports.MathFunctionMap = {
    up: Math.ceil,
    down: Math.floor,
    off: Math.round,
    '': Math.round, // 使用 off 和 digits 1
};
function round(value, type = 'off', digits = 1) {
    if (value == null)
        return 0;
    value = Number(value);
    if (type === exports.RoundingType[''] && digits === 0) {
        digits = 1;
    }
    if (type === exports.RoundingType['']) {
        type = exports.RoundingType.off;
    }
    const mathFunction = exports.MathFunctionMap[type];
    const digitsAdjust = Math.pow(10, digits);
    const roundedValue = mathFunction(value * digitsAdjust) / digitsAdjust;
    return roundedValue;
}
exports.default = round;
//# sourceMappingURL=round.js.map